import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy path: the Assets list lives at /assets. Bookmarks and old links keep
// working and land there with their search, without an extra history entry.
export const Route = createFileRoute("/_app/asset-tree")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/assets", search, replace: true });
  },
});
